import React, { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

function Video() {
   const isMobile = window.innerWidth < 900;
  const { scrollYProgress } = useScroll();
  const videoRef1 = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
 // console.log(scrollYProgress, "scrollYProgress")
  // Center column grows from 66% → 80%
  const centerWidth = useTransform(scrollYProgress, [0, 0.04], ["33%", "100%"]);

  // Left & right columns shrink from 17% → 10%
  const sideWidth = useTransform(scrollYProgress, [0, 0.04], ["33%", "0%"]);
 // console.log(sideWidth, "sideWidth")



  const handleCanPlay = () => {
    const video1 = videoRef1.current;
    if (video1) {
      const playPromise = video1.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // autoplay started successfully
          })
          .catch((error) => {
            console.warn("Autoplay prevented:", error);
          });
      }
    }
  };
  return (
    <>
      <div style={{ height: "20%" }}>
        <section className="video_section     overflow-hidden" >
          <div className="container-fluid mt-4">
            {(!isMobile)?<div className="row mb-4">
              <motion.div
                className="col-2 position-relative ps-0"
                style={{ width: sideWidth }}
              >
                <img
                  src="/assets/img/hero-left.png"
                  alt="img"
                  className="img-fluid hero-left"
                />
              </motion.div>

              <motion.div className="col-8" style={{ width: centerWidth }}>
                {/* <img
            src="/assets/img/video1.jpg"
            alt="img"
            className="img-fluid"
          /> */}
                <div style={{ position: 'relative' }}>
                  <video
                    ref={videoRef1}
                    autoPlay
                    muted={isMuted}
                    loop
                    playsInline
                    onCanPlayThrough={handleCanPlay}
                    className="w-100"

                  >
                    <source src="/assets/videos/human_performance.mp4" type="video/mp4" />
                  </video>
                  <button
                    onClick={() => setIsMuted(!isMuted)}
                    style={{


                      background: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "3px 6px",
                      cursor: "pointer",
                      position: 'absolute',
                      right: '6px',
                      top: '9%',
                      fontSize: '14px'
                    }}
                  >
                    {(isMuted) ? "🔇" : "🔊"}
                  </button>
                </div>




                {/* <video controls autoPlay muted loop className="w-100">
            <source src="/assets/videos/human_performance.mp4" type="video/mp4" />
          </video> */}
              </motion.div>

              <motion.div
                className="col-2 position-relative pe-0"
                style={{ width: sideWidth }}
              >
                <img
                  src="/assets/img/hero-right.png"
                  alt="img"
                  className="img-fluid hero-right"
                />
              </motion.div>
            </div>:  
            <div className="row mb-4">
              <div
                className="col-md-3 ps-0"
                style={{textAlign:"center"}}
                
              >
                <img
                  src="/assets/img/hero-left.png"
                  alt="img"
                  className=""
                   style={{width:'69%'}}
                />
              </div>

              <div className="col-md-6">
                {/* <img
            src="/assets/img/video1.jpg"
            alt="img"
            className="img-fluid"
          /> */}
                <div style={{ position: 'relative' }}>
                  <video
                    ref={videoRef1}
                    autoPlay
                    muted={isMuted}
                    loop
                    playsInline
                    onCanPlayThrough={handleCanPlay}
                    className="w-100"

                  >
                    <source src="/assets/videos/human_performance.mp4" type="video/mp4" />
                  </video>
                  <button
                    onClick={() => setIsMuted(!isMuted)}
                    style={{


                      background: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "3px 6px",
                      cursor: "pointer",
                      position: 'absolute',
                      right: '6px',
                      top: '9%',
                      fontSize: '14px'
                    }}
                  >
                    {(isMuted) ? "🔇" : "🔊"}
                  </button>
                </div>




                {/* <video controls autoPlay muted loop className="w-100">
            <source src="/assets/videos/human_performance.mp4" type="video/mp4" />
          </video> */}
              </div>

              <div
                className="col-md-3 pe-0"
              style={{textAlign:"center"}}
              >
                <img
                  src="/assets/img/hero-right.png"
                  alt="img"
                  className=""
                  style={{width:'69%'}}
                  
                />
              </div>
            </div>}
            {/* <img src="/assets/img/video2.jpg" alt="img" className="img-fluid" /> */}
          </div>
        </section>
      </div>
    </>
  );
}

export default Video;